import { client } from '@atlassian/rovo-content-bridge-api';

export const ROVO_INLINE_INPUT_BOX_CLIENT_ID = client('rovo-inline-input-box');
